var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.3158 0.549681C0.963818 0.902098 0.766115 1.37981 0.766115 1.8779C0.766115 2.37598 0.963818 2.8537 1.3158 3.20611L8.1323 10.0226L1.3158 16.8391C0.983792 17.1954 0.803047 17.6667 0.811638 18.1536C0.82023 18.6405 1.01749 19.1051 1.36185 19.4495C1.70622 19.7939 2.17081 19.9911 2.65774 19.9997C3.14467 20.0083 3.61593 19.8276 3.97223 19.4955L12.1169 11.3508C12.4689 10.9984 12.6666 10.5207 12.6666 10.0226C12.6666 9.52453 12.4689 9.04681 12.1169 8.6944L3.97223 0.549681C3.61981 0.197703 3.14209 0 2.64401 0C2.14593 0 1.66821 0.197703 1.3158 0.549681Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.df79e4e8d4685d39cb261eeb58bb1e60.svg";
export { ForwardRef as ReactComponent };